export default __webpack_public_path__ + "static/media/iso14001.650eee72.jpeg";